module.exports = __webpack_public_path__ + "img/zel.a6ad24ae.svg";